import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';
import * as c from '~js/utils/classes';

export class Addresses {
  constructor(section) {
    this.section = section;
    this.addressNewForm = this.section.querySelector(s.selectors$G.addressNewForm);
    this.accountForms = this.section.querySelectorAll(s.selectors$G.accountForm);

    this.init();
    this.validate();
  }

  init() {
    if (this.addressNewForm) {
      const section = this.section;
      const newAddressForm = this.addressNewForm;
      this.customerAddresses();

      const newButtons = section.querySelectorAll(s.selectors$G.btnNew);
      if (newButtons.length) {
        newButtons.forEach((button) => {
          button.addEventListener('click', function (e) {
            e.preventDefault();
            button.classList.add(c.classes$w.hidden);
            newAddressForm.classList.remove(c.classes$w.hidden);
          });
        });
      }

      const editButtons = section.querySelectorAll(s.selectors$G.btnEdit);
      if (editButtons.length) {
        editButtons.forEach((button) => {
          button.addEventListener('click', function (e) {
            e.preventDefault();
            const formId = this.getAttribute(a.attributes$q.dataFormId);
            section.querySelector(`[${s.selectors$G.editAddress}="${formId}"]`).classList.toggle(c.classes$w.hidden);
          });
        });
      }

      const deleteButtons = section.querySelectorAll(s.selectors$G.btnDelete);
      if (deleteButtons.length) {
        deleteButtons.forEach((button) => {
          button.addEventListener('click', function (e) {
            e.preventDefault();
            const formId = this.getAttribute(a.attributes$q.dataFormId);
            if (confirm(theme.strings.delete_confirm)) {
              Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
            }
          });
        });
      }

      const cancelButtons = section.querySelectorAll(s.selectors$G.btnCancel);
      if (cancelButtons.length) {
        cancelButtons.forEach((button) => {
          button.addEventListener('click', function (e) {
            e.preventDefault();
            this.closest(s.selectors$G.accountForm).classList.add(c.classes$w.hidden);
            document.querySelector(s.selectors$G.btnNew).classList.remove(c.classes$w.hidden);
          });
        });
      }
    }
  }

  customerAddresses() {
    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify.CountryProvinceSelector) {
      new Shopify.CountryProvinceSelector(s.selectors$G.addressCountryNew, s.selectors$G.addressProvinceNew, {
        hideElement: s.selectors$G.addressProvinceContainerNew,
      });
    }

    // Initialize each edit form's country/province selector
    const countryOptions = this.section.querySelectorAll(s.selectors$G.addressCountryOption);
    countryOptions.forEach((element) => {
      const formId = element.getAttribute(a.attributes$q.dataFormId);
      const countrySelector = `${s.selectors$G.addressCountry}_${formId}`;
      const provinceSelector = `${s.selectors$G.addressProvince}_${formId}`;
      const containerSelector = `${s.selectors$G.addressProvinceContainer}_${formId}`;

      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector,
      });
    });
  }

  validate() {
    this.accountForms.forEach((accountForm) => {
      const form = accountForm.querySelector('form');
      const inputs = form.querySelectorAll(s.selectors$G.requiredInputs);

      form.addEventListener('submit', (event) => {
        let isEmpty = false;

        // Display notification if input is empty
        inputs.forEach((input) => {
          if (!input.value) {
            input.nextElementSibling.classList.add(c.classes$w.validation);
            isEmpty = true;
          } else {
            input.nextElementSibling.classList.remove(c.classes$w.validation);
          }
        });

        if (isEmpty) {
          event.preventDefault();
        }
      });
    });
  }
}